export const listonespaceswitchConstants = {
    SPACE_LIST: 'SPACE_LIST',
    ONE_SPACE: 'ONE_SPACE',

    SPACE_LIST_NR: 0,
    ONE_SPACE_NR: 1,
};